import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { SwitcherService } from 'src/app/shared/services/switcher.service';

@Component({
    selector: 'app-full-layout',
    templateUrl: './full-layout.component.html',
    styleUrls: ['./full-layout.component.scss'],
    standalone: false
})

export class FullLayoutComponent implements OnInit, OnDestroy {

  public isMobile = window.matchMedia("(max-width: 991px)").matches;
  public currentUrl = '';
  private routerSub?: Subscription;

  constructor(
    public SwitcherService : SwitcherService,
    private router: Router
  ) { }
  // app-notification-sidebar
  
  ngOnInit(): void {
    this.currentUrl = this.router.url || '';
    this.routerSub = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.currentUrl = event.urlAfterRedirects || event.url || '';
      }
    });
  }
  

  ngOnDestroy(){
    this.routerSub?.unsubscribe();
  }
  
  mainSidebarOpen: any;
  hoverEffect($event:any) {
    this.mainSidebarOpen = $event.type == 'mouseover' ? 'sidenav-toggled-open' : '';
  }

  clickOnBody(){
    this.SwitcherService.emitChange(false);
    
  }

  scrolled: boolean = false;


  @HostListener('window:resize', [])
  onWindowScroll() {
    const isSmall = window.matchMedia("(max-width: 991px)").matches;
    this.scrolled = isSmall;
    this.isMobile = isSmall;
  }

  get showSidemenu(): boolean {
    return !this.isMobile;
  }


}
